import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { newHavenConfig } from "./data";

export default function NewHavenPage() {
  return <CityPageTemplate config={newHavenConfig} />;
}